import React from "react";
import styled from "styled-components";
import { LibertifyLogo } from "./LibertifyLogo";

export type AuthFormPanelProps = {
  title: string;
  children: React.ReactNode;
};

export const AuthFormPanel: React.FC<AuthFormPanelProps> = ({
  title,
  children,
}) => (
  <FormPanel>
    <FormLogo>
      <LibertifyLogo />
    </FormLogo>
    <FormTitle>{title}</FormTitle>
    <FormFields>{children}</FormFields>
  </FormPanel>
);

const FormPanel = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 40px;
    width: auto;
  }
`;

const FormTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 24px 0 0;
  text-align: center;
  line-height: 1.2;
  letter-spacing: -0.02em;
`;

const FormFields = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;
